import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { GetProductSubscriptionDatesDialogComponent } from './get-product-subscription-dates-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { NumberInputModule } from '../../form/number-input/number-input.module';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DirectivesModule } from '@shared/directives/directives.module';
import { ProductPriceLabelModule } from '../../product-price-label/product-price-label.module';
import { BcmPipesModule } from '@modules/bcm/@shared/pipes/pipes.module';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { DateFnsModule } from 'ngx-date-fns';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import {ProductDynamicPriceModule} from '@bcm-work-flows/product-dynamic-price/product-dynamic-price.module';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
    declarations: [
        GetProductSubscriptionDatesDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,

        FuseSharedModule,
        FuseWidgetModule,
        DragDropModule,
        NumberInputModule,
        SharedModule,
        MatSelectModule,
        MatDatepickerModule,
        DirectivesModule,
        ProductPriceLabelModule,
        BcmPipesModule,
        DateTimeInputModule,
        DateFnsModule,
        MatCheckboxModule,
        MatRadioModule,
        MatExpansionModule,
        ProductDynamicPriceModule,
        MatTooltipModule,
    ],
})
export class GetProductSubscriptionDatesDialogModule {
}
